import { AppStatus } from "api/app-status";
import { isMobileOrTablet } from "utils/device";
import { StateCreator } from "zustand";

export interface MiscellaneousSlice {
  miscellaneous: {
    appStatus: AppStatus | null;
    isAppFocused: boolean;
    isMobileDevice: boolean;
    realtimeSubscribed: boolean;
    showIOSAddToHomeScreenTooltip: boolean;
    smallAvatars: {
      [key: string]: Blob;
    };
    set: (props: Partial<MiscellaneousSlice["miscellaneous"]>) => void;
  };
}

const createMiscellaneousSlice: StateCreator<MiscellaneousSlice, [], [], MiscellaneousSlice> = (set) => ({
  miscellaneous: {
    appStatus: null,
    isAppFocused: true,
    isMobileDevice: isMobileOrTablet(),
    realtimeSubscribed: false,
    showIOSAddToHomeScreenTooltip: true,
    smallAvatars: {},
    set: (props) =>
      set((state) => {
        if (props.smallAvatars && Object.keys(props).length === 1) {
          return {
            miscellaneous: {
              ...state.miscellaneous,
              smallAvatars: {
                ...state.miscellaneous.smallAvatars,
                ...props.smallAvatars,
              },
            },
          };
        }

        if (props.smallAvatars && Object.keys(props).length > 1) {
          throw new Error("'smallAvatars' prop can't be passed along other props of the miscellaneous store slice.");
        }

        return { miscellaneous: { ...state.miscellaneous, ...props } };
      }),
  },
});

export default createMiscellaneousSlice;
